/*
  This file is part of Universal Sequences.

  Universal Sequences is free software: you can redistribute it and/or modif
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  Universal Sequences is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { Component } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import { Group, Stage, Layer, Rect, Line} from 'react-konva';
import BasicPoints from './BasicPoints.js';
import {crop} from 'engine/Crop.js';
import { Button } from 'reactstrap';
import Colors from 'components/Colors.js';
import Markers from './Markers.js';
import ethereum from 'decentralized/ethereum.js';
import { ReactReduxContext, Provider } from 'react-redux';
import SliceDetails from '../installation/SliceDetails.js';
import TimeRuler from './TimeRuler.js';
import SampleTempo from "components/waveform/SampleTempo.js";
import WaveformCache from 'repos/WaveformCache.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import Onsets from './Onsets.js';
import WarpButton from 'components/WarpButton.js';
import Tone from 'tone';
import PlayTick from './PlayTick.js';
import Sample from 'repos/Sample.js';
import {
    setContextualHelp,
    setOnsetThreshold,
    setShowOnsets,
    setWaveformShowing,
    setSelectedOnsets} from "actions/index.js";
import {TRACK_WAVEFORM} from 'constants/contextual-help.js';
import { connect } from "react-redux";
import {getWidth, WIDTH, HEIGHT, START, END} from './constants.js';

const colors = new Colors();

const MIN_SLICE = 0.001;

const FINE_GRAIN = 0.001;

window.waveWidth = 1;
window.waveOpacity = 0.8;

var waveformCache = new WaveformCache(WIDTH, HEIGHT);

class BasicWaveform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            slicing: false,
            dragging: false,
            showColors: true,
            end: null,
            buffer: props.buffer,
            isPlaying: false,
            pts: [],
            slices: props.slices,
            fetchedSlices: undefined,
            dragging: false,
            selection: null,
            zoomedBuffer: undefined,
            zommedIn: false,
            zoomedStartTime: 0,
            zoomedScale: 1,
            directionMode: START,
            selectedRecording: this.props.track.selectedRecording,
            xBounds: 0,
        };

        this.ref = React.createRef();

        this.scale = 1;

        this.width = props.width || getWidth(this.props.div);
        this.height = props.height || HEIGHT;

        if (waveformCache.width !== this.width ||
            waveformCache.height !== props.height) {
            waveformCache = new WaveformCache(this.width, this.height);
        }

        this.markersDragging= false;

        // find out now if we have slices saved, in case they want to load it
        let sample = new Sample(this.props.soundId);

        this.state.start = this.convertSecondsToSpace(props.start) / 2;
        this.state.startX = this.convertSecondsToSpace(props.start);
        this.state.end = this.convertSecondsToSpace(props.end) / 2;
        this.state.endX = this.convertSecondsToSpace(props.end);

        if (this.props.isReversed) {
            waveformCache.getReversedWaveform(this.props.soundId, this.props.buffer)
                .then(waveform => {
                    this.setState({pts: waveform});
                });
        } else {
            waveformCache.getWaveform(this.props.soundId, this.props.buffer)
                .then(waveform => {
                    this.setState({pts: waveform});
                });
        }
        this.convertSpaceToSeconds.bind(this);
        this.computeWaveformPoints.bind(this);

        this.onWheel = this.onWheel.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidMount() {
        if (!this.props.hideButtons) {
            this.ref.current.addEventListener("mousewheel", this.onWheel, {passive: false});
            window.addEventListener("keydown", this.onKeyDown);
        }
        if (this.props.xBounds !== undefined) {
            this.state.xBounds = this.props.xBounds;
        } else {
            /*
            setTimeout(() => {
                let waveform = document.getElementsByClassName("sound-waveform")[0];
                if (waveform) {
                    this.state.xBounds = waveform.offsetLeft;
                }
            }, 1000);
            */
        }
        this.props.setWaveformShowing(true);
    }

    onKeyDown(e) {
        if (e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA') {
            return;
        }

        if (e.key === "ArrowLeft") {
            e.preventDefault();
            this.onArrowLeft(e.metaKey || e.ctrlKey);
        }
        if (e.key === "ArrowRight") {
            e.preventDefault();
            this.onArrowRight(e.metaKey || e.ctrlKey);
        }
        if (e.key === 'Tab') {
            e.preventDefault();
            this.onArrowUp();
        }
    }

    onArrowDown() {
        let selectedSlice = this.props.selectedSlice || 0;
        this.props.onSelectSlice(selectedSlice === 0 ? this.props.sampler.slices.length - 1 : selectedSlice - 1);
    }

    onArrowUp() {
        let selectedSlice = this.props.selectedSlice || 0;
        this.props.onSelectSlice((selectedSlice + 1) % this.props.sampler.slices.length);
    }

    onArrowRight(onsets) {
        let slices = this.props.sampler.slices;
        if (this.props.selectedSlice !== undefined) {
            let slice = slices[this.props.selectedSlice];
            if (this.state.directionMode === START) {
                if (onsets) {
                    // get the onsets
                    let nextOnset = this.props.sampler.onsets.find(x => x / 1000.0 > slice.startTime);
                    if (nextOnset) {
                        this.props.sampler.slice(
                            this.props.selectedSlice,
                            nextOnset / 1000.0,
                            nextOnset / 1000 + (slice.endTime - slice.startTime));
                    }
                } else {
                    this.props.sampler.slice(
                        this.props.selectedSlice,
                        Math.min(slice.endTime, slice.startTime + this.fineGrain),
                        slice.endTime);
                }
            } else {
                this.props.sampler.slice(
                    this.props.selectedSlice,
                    slice.startTime,
                    Math.min(this.props.sampler.getDuration(), slice.endTime + this.fineGrain));
            }
        }
    }

    onArrowLeft(useOnsets) {
        let slices = this.props.sampler.slices;
        if (this.props.selectedSlice !== undefined) {
            let slice = slices[this.props.selectedSlice];
            if (this.state.directionMode === START) {
                if (useOnsets) {
                    let _onsets = [... this.props.sampler.onsets];
                    _onsets.reverse();
                    let prevOnset = _onsets.find(x => x / 1000.0 < slice.startTime) || 0;
                    this.props.sampler.slice(
                        this.props.selectedSlice,
                        prevOnset / 1000.0,
                        (prevOnset / 1000.0) + (slice.endTime - slice.startTime));
                } else {
                    this.props.sampler.slice(
                        this.props.selectedSlice,
                        Math.max(0, slice.startTime - this.fineGrain),
                        slice.endTime);
                }
            } else {
                this.props.sampler.slice(
                    this.props.selectedSlice,
                    slice.startTime,
                    Math.max(slice.startTime, slice.endTime - this.fineGrain));
            }
        }
    }

    get fineGrain() {
        let dur = this.props.sampler.getDuration();
        return FINE_GRAIN * dur;
    }

    componentWillUnmount() {
        if (!this.props.hideButtons) {
            this.ref.current.removeEventListener("mousewheel", this.onWheel);
            window.removeEventListener("keydown", this.onKeyDown);
        }
        this.props.setWaveformShowing(false);
    }

    shouldComponentUpdate(nextProps) {
        if (waveformCache.width !== (nextProps.width || getWidth(nextProps.div))) {
            waveformCache = new WaveformCache(nextProps.width || getWidth(nextProps.div), this.height);
            this.width = nextProps.width || getWidth(nextProps.div);
            waveformCache.getWaveform(nextProps.soundId, nextProps.buffer)
                .then(waveform => {
                    this.setState({pts: waveform});
                });
        }

        if (waveformCache.height !== nextProps.height) {
            this.height = nextProps.height;
            waveformCache = new WaveformCache(getWidth(nextProps.div), nextProps.height);
            waveformCache.getWaveform(nextProps.soundId, nextProps.buffer)
                .then(waveform => {
                    this.setState({pts: waveform});
                });
        }
        if (this.props.isReversed != nextProps.isReversed ||
            nextProps.soundId !== this.props.soundId || 
            nextProps.track.selectedRecording !== this.state.selectedRecording) {
            this.state.selectedRecording = nextProps.track.selectedRecording;
            if (nextProps.isReversed) {
                waveformCache.getReversedWaveform(nextProps.soundId, nextProps.buffer)
                    .then(waveform => {
                        this.setState({pts: waveform});
                    });
            } else {
                waveformCache.getWaveform(nextProps.soundId, nextProps.buffer)
                    .then(waveform => {
                        this.setState({pts: waveform});
                    });
            }
            
        }
        return true;
    }

    async computeWaveformPoints(buffer, chunkNumber, prevList, callback) {
        this.index++;
        let index = this.index;
        const chunkSize = this.width;
        if ((chunkNumber + 1)*chunkSize > this.width) {
            callback([]);
            return;
        } 

        var step = Math.floor(buffer.length / this.width);
        var channel = buffer.getChannelData(0);
        channel = channel.subarray(chunkSize*chunkNumber*step, chunkSize*(chunkNumber + 1)*step);
        let p = window.api.create_buffer(channel.length);
        var maxWidth = Math.min((chunkNumber + 1) * chunkSize, this.width);
        window.Module.HEAPF32.set(channel, p >> 2);
        let pointWidth = 1; // Math.ceil(3 / Math.pow(this.scale, 1.5));
        window.api.getColoredWaveform(p, chunkSize, this.height, channel.length, step, chunkSize*chunkNumber, pointWidth);
        const resultPointer = window.api.get_result_pointer();
        const resultView = new Uint16Array(window.Module.HEAP16.buffer, resultPointer, chunkSize*7/pointWidth);
        let list = [];

        if (index < this.index) {
            return;
        }

        for (var i=0; i < chunkSize*7/pointWidth; i+=7) {
            let rgb = [resultView[i+4], resultView[i+5], resultView[i+6]];
            list.push({x:resultView[i], y: resultView[i+1], width: resultView[i+2], height: resultView[i+3], rgb: rgb});
        }


        var self = this;

        if (index < this.index) {
            return;
        }
        let pts = prevList.concat(list);

        self.setState({
            pts: pts
        });

        window.api.destroy_buffer(p);
    };

    get duration() {
        return this.props.buffer.duration;
    }

    convertSpaceToSeconds(x, noOffset=false) {
        if (this.props.div && !noOffset) {
            x -= this.props.div.current.getBoundingClientRect().left;
        }
        let buffer = this.state.zoomedIn ? this.state.zoomedBuffer : this.props.buffer;
        return buffer.duration * x / this.width
    }

    convertSecondsToSpace(x) {
        let buffer = this.state.zoomedIn ? this.state.zoomedBuffer : this.props.buffer;
        return x / buffer.duration * this.width
    }

    newSlice(evt) {
        if (this.state.slicing) {
            this.props.sampler.newSlice(this.convertSpaceToSeconds(evt.evt.layerX));
            this.state.slices = this.props.sampler.slices;
            this.state.slicing = false;
            this.setState(this.state);
            this.props.onSelectSlice(this.state.slices.length - 1);
        }
    }

    getSlices() {
        let slices = this.props.sampler.slices.map(
            (slice, i) =>
                {
                    let s = slice.getCopy();
                    s.startTime -= this.state.zoomedStartTime;
                    if (s.startTime < 0 && s.startTime >= -0.1) {
                        s.startTime = 0;
                    }
                    s.endTime -= this.state.zoomedStartTime;
                    s.i = i;
                    return s;
                });

        slices = slices
            .filter(s => s.startTime >= 0);

        let selectedSlice = -1;
        for (let i in slices) {
            if (slices[i].i === this.props.selectedSlice) {
                selectedSlice = i;
                break;
            }
        }
        if (selectedSlice === -1) {
            return slices;
        }
        selectedSlice = slices.splice(selectedSlice, 1);
        return selectedSlice.concat(slices);
    }

    onClickShowOnsets() {
        this.props.setShowOnsets(!this.props.showingOnsets);
    }

    onClickAddSlice(evt) {
        evt.target.blur();
        if (this.props.showingOnsets && this.selectedOnsets.length > 0) {
            for (let i in this.selectedOnsets) {
                let startTime = this.onsets[this.selectedOnsets[i]];
                let endTime = this.onsets[this.selectedOnsets[i] + 1];

                this.props.sampler.newSlice(startTime / 1000.0, endTime / 1000.0);
                this.state.slices = this.props.sampler.slices;
                this.props.onSelectSlice(this.state.slices.length - 1);
            }
            this.props.setSelectedOnsets([]);
            this.props.setShowOnsets(false);
            return;
        }

        if (this.state.selection !== null) {
            let start = this.convertSpaceToSeconds(this.state.selection.start, true);
            let end = this.convertSpaceToSeconds(this.state.selection.end, true);
            if (end - start < MIN_SLICE) {
                return;
            }
            this.props.sampler.newSlice(this.state.zoomedStartTime + start, end + this.state.zoomedStartTime);
            this.setState({
                selection: null,
                slices: this.props.sampler.slices
            });
            
            this.props.onSelectSlice(this.props.sampler.slices.length - 1);
        } 
    }

    onClickDeleteSlice() {
        this.props.sampler.deleteSlice(this.props.selectedSlice);
        this.setState(this.state);
    }

    onClickAutoSlice() {
        let notes = this.props.sample.noteSequence.notes;
        notes.forEach(note => {
            this.props.sampler.newSlice(note.startTime, note.endTime);
        });

        this.setState(this.state);
    }

    async onClickLoadSlices() {
        if (this.props.decentralized) {
            let sample = new Sample(this.props.soundId);
            this.props.sampler.slices = [];
            this.setState(this.state);
            let slices = 
                await sample.fetchSlices(); 
            slices.forEach(slice => this.props.sampler.newSlice(slice.startTime, slice.endTime));
            this.setState(this.state);

        }
    }

    onClickSaveSlices() {
        // save the slices  to ethereum, so that people can load the slices
        // later by clicking a button
        if (this.props.decentralized) {
            let starts = this.props.sampler.slices.map(slice => Math.floor(slice.startTime * 1000));
            let ends = this.props.sampler.slices.map(slice => Math.floor(slice.endTime* 1000));
            let ipfsHash = this.props.soundId;
            ethereum.newSlices(this.props.soundId, starts, ends);
        }
    }

    get onsets() {
        return this.props.sampler.onsets;
    }

    get selectedOnsets() {
        return this.props.track.sequencerEngine.store.getState().waveform
            .selectedOnsets[this.props.sample.getId()] || [];
    }

    onMouseDown(evt) {
        evt.evt.stopPropagation();
        let x = evt.evt.layerX;
        if (this.markersDragging) {
            return;
        }

        if (this.props.showingOnsets) {
            let milli= (this.state.zoomedStartTime  +
                        this.convertSpaceToSeconds(x)) * 1000;

            let selected = -1;
            for (let i=0; i < this.onsets.length; i++) {
                let currentOnset = this.onsets[i];
                if (currentOnset < milli) {
                    if (i === this.onsets.length - 1) {
                        selected = i;
                    } else if (this.onsets[i + 1] > milli) {
                        selected = i;
                    }
                }
            }

            if (selected !== -1) {
                let i = this.selectedOnsets.indexOf(selected);
                if (i > -1) {
                    let selectedOnsets = [... this.selectedOnsets];
                    selectedOnsets.splice(i, 1);
                    this.props.setSelectedOnsets(selectedOnsets);
                } else {
                    this.props.setSelectedOnsets(
                        [...this.selectedOnsets, selected]);
                }
            }
        }    
        
        if (this.state['dragging']) {
            this.setState({dragging: false});
        } else {
            this.setState({'selection': {start: x, end: x},
                           'dragging': true});
        }
    }

    onMouseMove(evt) {
        let x = evt.evt.layerX;

        if (this.markersDragging) {
            let isEnd = this.state.endSliceDragging !== undefined;
            let seconds = Math.max(0, this.convertSpaceToSeconds(x - this.state.offset, true));
            if (this.state.selection) {
                this.state.selection = null;
            }
            this.changeTheSlice(seconds + this.state.zoomedStartTime);
            return;
        }
        this.state.mouseX = evt.evt.layerX;
        if (this.div && this.div.current) {
            this.state.mouseX -= this.div.current.getBoundingClientRect().left;

        }
        if (this.state['dragging']) {
            this.setState({selection : {start: this.state['selection']['start'], end: evt.evt.layerX}});
        }
    }

    changeTheSlice(sec) {
        let slices = this.props.sampler.slices;
        if (this.state.startSliceDragging !== undefined) {
            let slice = slices[this.state.startSliceDragging];
            if (sec + 0.001 >= slice.endTime) {
                return;
            }
            if (this.ctrl) {
                // move both start/end pts together
                let dist = sec - slice.startTime;
                this.props.sampler.slice(
                    this.state.startSliceDragging,
                    sec,
                    slice.endTime + dist);
            } else {
                this.props.sampler.slice(
                    this.state.startSliceDragging,
                    sec,
                    slice.endTime);
            }
        } else if (this.state.endSliceDragging !== undefined) {
            let slice = slices[this.state.endSliceDragging];
            if (slice.startTime + 0.001 >= sec) {
                return;
            }
            if (this.ctrl) {
                let dist = sec - slice.endTime;
                this.props.sampler.slice(
                    this.state.endSliceDragging,
                    slice.startTime + dist,
                    sec);
            } else {
                this.props.sampler.slice(
                    this.state.endSliceDragging,
                    slice.startTime,
                    sec);
            }
        }
    }

    endDrag(evt) {
        if (this.markersDragging) {
            this.state.startSliceDragging = undefined;
            this.state.endSliceDragging = undefined;
            this.markersDragging = false;
            return;
        }
        this.state.dragging = false;
    }

    scrollWaveform(delta) {
        delta /= (700 * this.scale / this.duration);
        let start = this.state.zoomedStartTime || 0;
        start += delta;
        let end = this.buffer.duration + this.state.zoomedStartTime;
        end += delta;

        if (start < 0 || end > this.duration) {
            return;
        }

        let sampleRate = Tone.Master.context.sampleRate;
        this.state.zoomedStartTime = start;
        let cropped = crop(this.props.buffer, start * sampleRate, end * sampleRate, Tone.Master.context);
        this.state.zoomedBuffer = cropped;
        this.setState(this.state);
        this.computeWaveformPoints(cropped, 0, [], function(ret) {
        });
    }

    cropSelection() {
        let start = this.state.zoomedStartTime + this.convertSpaceToSeconds(this.state.selection.start);
        let end = this.state.zoomedStartTime + this.convertSpaceToSeconds(this.state.selection.end);
        this.props.crop(start, end);
    }

    zoomIn(startX, scale) {
        scale *= 2;
        if (scale <= 2) {
            this.zoomOut();
            return;
        }
        

        let zoomedStartTime = this.state.zoomedStartTime || 0;
        let goalDuration = this.duration / scale;
        // now we have to fit the start and end to equal goal duration
        // and we want the pointerSeconds to occur at startX position
        let actualSeconds = zoomedStartTime + this.convertSpaceToSeconds(startX, true);
        let goalSeconds = goalDuration * startX / this.width;
        let start = actualSeconds - goalSeconds;
        let end = start + goalDuration;
        
        if (start < 0) {
            start = 0;
        }
        if (end - start < 0.001) {
            return;
        }
        let buffer = this.props.buffer;
        this.state.zoomedStartTime = start;
        this.state.zoomedScale = scale;
        this.state.zoomedIn = true;
        let sampleRate = Tone.Master.context.sampleRate;
        let cropped = crop(buffer, start * sampleRate, end * sampleRate, Tone.Master.context);
        this.state.zoomedBuffer = cropped;
        this.computeWaveformPoints(cropped, 0, [], function(ret) {
        });
    }

    zoomOut() {
        this.state.zoomedIn = false;
        this.state.zoomedStartTime = 0;
        this.state.zoomedBuffer = undefined;
        this.state.selection = null;
        this.computeWaveformPoints(this.props.buffer, 0, [], function(ret) {
        });
    }

    markerDraggingStarted() {
        this.markersDragging = true;
        this.setState({
            selection: null,
            dragging: false,
        });
    }

    markerDraggingEnded() {
        this.markersDragging = false;
        this.setState({
            selection: null,
            dragging: false
        });
    }

    onClickSyncTempo() {
        var sampler = this.props.sampler;
        if (!sampler.tempoSynced) {
            sampler.syncTempo(Tone.Transport.bpm.value);
        } else {
            sampler.unsyncTempo();
        }
        document.activeElement.blur()
        this.setState(this.state);
    }

    onMouseOver(e) {
    }

    onWheel(e) {
        e.stopPropagation();
        if (e.ctrlKey) {
            e.preventDefault();
            let zoomScale = this.scale - e.deltaY * 0.01;
            if (zoomScale <= 1) {
                zoomScale = 1;
            }

            this.zoomIn(this.state.mouseX, zoomScale);
            this.scale = zoomScale;
        } else {
            let delta = e.deltaX;
            if (Math.abs(delta) > 0) {
                e.preventDefault();
                this.scrollWaveform(delta);
            }
        }
    }

    get buffer() {
        return this.state.zoomedBuffer || this.props.buffer;
    }

    onStartSliceStartedDragging(offset, slice, ctrl) {
        this.ctrl = ctrl;
        if (this.props.div && this.props.div.current) {
            offset -= this.props.div.current.getBoundingClientRect().left;
        }
        this.markersDragging = true;
        this.props.onSelectSlice(slice);
        this.state.offset = offset;
        this.state.startSliceDragging = slice;
        this.setState({
            directionMode: START
        });
    }

    onStartSliceStoppedDragging(slice) {
        this.markersDragging = false;
        this.state.startSliceDragging = undefined;
    }

    onEndSliceStartedDragging(offset, slice, ctrl) {
        this.ctrl = ctrl;
        if (this.props.div && this.props.div.current) {
            offset -= this.props.div.current.getBoundingClientRect().left;
        }
        this.markersDragging = true;
        this.props.onSelectSlice(slice);
        this.state.endSliceDragging = slice;
        this.state.offset = offset;
        this.setState({
            directionMode: END
        });
    }

    onEndSliceStoppedDragging(slice) {
        this.markersDragging = false;
        this.state.endSliceDragging = undefined;
    }

    onChangeOnsetThreshold(t) {
        this.props.setOnsetThreshold(t);
        this.props.sampler.analyze();
        this.setState(this.state);
    }

    onClickAutoSlice() {
        this.props.sampler.autoSlice(4);
        this.setState(this.state);
    }

    onMouseOver() {
        this.mousedOver = true;
    }

    onMouseLeave(e) {
        this.endDrag(e);
        this.mousedOver = false;
    }

    onGatedChange(opt) {
        document.activeElement.blur()
        this.props.track.gated = opt.target.value === 'gated';
        this.props.sampler.release();
        this.setState(this.state);
    }

    render() {
        var pts = this.state.pts; 
        let track  = this.props.track;
        let color = colors.getColorForTrack(track);
        var self = this;
        let selection = this.state.selection == null ? {start: 0, end:0} : this.state.selection;
        let buffer = this.state.zoomedIn ? this.state.zoomedBuffer : this.props.buffer;
        let selectedSlice = this.getSlices()[this.props.selectedSlice];
        let sliceStart = selectedSlice === undefined ? 0 : this.convertSecondsToSpace(selectedSlice.startTime);
        let sliceEnd = selectedSlice === undefined ? 0 : this.convertSecondsToSpace(selectedSlice.endTime);
        let selectedSliceColor = selectedSlice === undefined ? 'black' : colors.getColor(this.props.selectedSlice);

        var tempo = Math.round(100 * this.props.sampler.tempo) / 100.0;
        var sampler = this.props.sampler;

        let style = {
        };
        if (this.props.track) {
            style.borderColor = colors.getColorForTrack(this.props.track);
        }

        let waveform = (
            <div
              style={style}
              ref={this.ref}
              className="sound-waveform details-view"
              onMouseOver={(e) => this.onMouseOver(e)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}> 
              <Stage
                onMouseOver={(e) => this.onMouseOver()}
                onMouseDown={(evt) => this.onMouseDown(evt)} 
                onMouseUp={(evt) => this.endDrag(evt)} 
                onMouseMove={(evt) => this.onMouseMove(evt)}
                onMouseLeave={(evt) => this.onMouseLeave(evt)}
                width={this.width + 2}
                height={this.height}>
                <Provider store={this.props.track.sequencerEngine.store}>
                  <Layer>
                    <Rect
                      onClick={(evt) => this.newSlice(evt)}
                      x={0}
                      y={0}
                      width={this.width}
                      height={this.height}
                      fill={this.props.backgroundColor ? this.props.backgroundColor :
                            this.props.small ? "black" : '#222222cf'}/>
                    {!this.props.small ?
                     <TimeRuler
                       convertSecondsToSpace={(x) => this.convertSecondsToSpace(x)}
                       fullDuration={this.duration}
                       height={this.height}
                       zoomedStartTime={this.state.zoomedStartTime}
                       buffer={buffer}
                       width={this.width}/> : []}
                    <Onsets
                      height={this.height}
                      width={this.width}
                      buffer={buffer}
                      showingOnsets={this.props.showingOnsets}
                      zoomedStartTime={this.state.zoomedStartTime}
                      sampleId={this.props.sample.getId()}
                      sampler={this.props.sampler}
                      onUpdate={() => this.setState(this.state)}/>
                    {this.markersDragging ?
                     [] :
                     <Rect
                       x={selection.start}
                       y={0}
                       width={selection.end - selection.start}
                       height={this.height}
                       fill='orange'/>}
                  </Layer>
                  <BasicPoints color={color} pts={pts} showColors={this.state.showColors}/>
                  <Layer>
                    {this.getSlices().map(
                        (slice, i) =>
                            <Markers
                              key={"marker-"+ i}
                              mode={this.state.directionMode}
                              small={this.props.small}
                              height={this.height}
                              width={this.width}
                              transposeParameter={this.props.track.trackData.transposeParameter}
                              scale={this.state.zoomedScale}
                              onStartSliceStartedDragging={(e, ctrl) => this.onStartSliceStartedDragging(e, slice.i, ctrl)}
                              onStartSliceStoppedDragging={() => this.onStartSliceStoppedDragging(slice.i)}
                              onEndSliceStartedDragging={(e, ctrl) => this.onEndSliceStartedDragging(e, slice.i, ctrl)}
                              onEndSliceStoppedDragging={() => this.onEndSliceStoppedDragging(slice.i)}
                              onKeyDown={this.props.onKeyDown}
                              isSelectedSlice={this.props.selectedSlice === slice.i}
                              buffer={buffer}
                              onSelectSlice={() => this.props.onSelectSlice(slice.i)}
                              track={this.props.track}
                              sliceNumber={slice.i}
                              sampler={this.props.sampler}
                              zoomedStartTime={this.state.zoomedStartTime}
                              color={this.props.color || colors.getColor(slice.i)}/>)}
                  </Layer>
                  <Layer>
                    <PlayTick
                      width={this.width}
                      sampler={sampler}
                      sequencerEngine={this.props.track.sequencerEngine}
                      soundId={this.props.soundId}
                      height={this.height} convertSecondsToSpace={(s) => this.convertSecondsToSpace(s - this.state.zoomedStartTime)}/>
                  </Layer>
               </Provider>
              </Stage>
            </div>
        );

        if (this.props.hideButtons) {
            return waveform;
        }


        let addButtonClass = "add-slice-button details-button";
        let showCrop = true;
        if (this.state.selection === null ||
            this.state.selection.end - this.state.selection.start <= 1) {
            if (!this.props.showingOnsets || this.selectedOnsets.length === 0) {
                addButtonClass += " disabled";
                showCrop = false;
            }
        }
        return (
            <div className="waveform-container">
              {waveform}
              <div className="waveform-buttons">
                <div
                  className={addButtonClass}
                  onClick={(e) => this.onClickAddSlice(e)}>
                  <div className="inner">
                    Slice
                  </div>
                </div>
                <div
                  className={this.props.sampler.slices.length > 1 ? "details-button delete-slice" :
                             "details-button delete-slice disabled"}
                  onClick={(e) => this.onClickDeleteSlice(e)}>
                  <div className="inner">
                    <div>Delete Slice</div>
                    <div style={{backgroundColor: selectedSliceColor}} className="dot"/>
                  </div>
                </div>
                <ConditionedComponent condition={tempo !== 0}>
                  <div
                    onClick={() => this.onClickShowOnsets()}
                    className="details-button onsets-btn">
                    <div className="inner">
                      {this.props.showingOnsets ? 'Hide Onsets' : 'Show Onsets'}
                    </div>
                  </div>
                  <div
                    onClick={() => this.onClickAutoSlice()}
                    className={this.props.sampler.slices.length > 1 ? "disabled details-button auto-slice-btn" : "details-button auto-slice-btn"}>
                    <div className="inner">
                      Auto-Slice
                    </div>
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.zoomedStartTime > 0}>
                  <div
                    onClick={() => this.zoomOut()}
                    className="details-button zoom-out-btn">
                    <div className="inner">
                      Zoom Out
                    </div>
                  </div>
                </ConditionedComponent>
                <SampleTempo sampler={sampler} track={this.props.track}/>
                <div className="radio gate-btn">
                  <label>
                    <input className="filter-radio"
                           type="radio"
                           value="gated"
                           checked={track.gated}
                           onChange={(e) => this.onGatedChange(e)} />
                    <div>Gated</div>
                  </label>
                  <label>
                    <input className="filter-radio"
                           type="radio"
                           value="ungated"
                           checked={!track.gated}
                           onChange={(e) => this.onGatedChange(e)} />
                    <div>Ungated</div>
                  </label>
                </div>
                <div className="radio reverse">
                  <label>
                    <input 
                      type="checkbox"
                      value="reversed"
                      checked={this.props.track.isReversed()}
                      onChange={(e) => this.props.onChangeReversed(e.target.value)} />
                    
                    <div>Reversed</div>
                  </label>
                </div>
                <ConditionedComponent condition={showCrop}>
                  <div
                    onClick={() => this.cropSelection()}
                    className="details-button crop-btn">
                    <div className="inner crop-button">
                      Crop In-Place
                    </div>
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={!showCrop}>
                  <div
                    onClick={() => this.props.cropSlices()}
                    className="details-button crop-btn">
                    <div className="inner crop-button">
                      Crop Slices
                    </div>
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.props.showingOnsets}>
                  <div className="onset-threshold-container">
                    <div>
                      Onset Threshold: {this.props.onsetThreshold} db
                    </div>
                    <ReactBootstrapSlider
                      value={this.props.onsetThreshold}
                      change={(e) => this.onChangeOnsetThreshold(e.target.value)}
                      step={0.01}
                      max={6}
                      min={-10}
                      orientation="horizontal"
                      reversed={false}
                    /> 
                  </div>
                </ConditionedComponent>
              </div>
              <SliceDetails slice={this.props.selectedSlice} sampler={sampler}/>
            </div>);
        
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setOnsetThreshold: (t) => dispatch(setOnsetThreshold(t)),
        setSelectedOnsets: (selectedOnsets) => dispatch(setSelectedOnsets(
            props.sample.getId(), selectedOnsets)),
        setShowOnsets: (show) => dispatch(setShowOnsets(show)),
        setWaveformShowing: (show) => dispatch(setWaveformShowing(show)),
    };
}

const mapStateToProps = (state, props) => {
    return {
        onsetThreshold : state.waveform.onsetThreshold,
        showingOnsets: state.waveform.showingOnsets,
        slicesLenggth: props.sampler.slices.length,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BasicWaveform);
